const entities = {
  createAnEntity: 'Créer une entité',
  createAnItem: 'Créer un item',
  entities: 'Entités',
  items: 'Items',
  noEntitiesToDisplay: 'Aucune entité à afficher',
  noItemsToDisplay: 'Aucun item à afficher',
  xSelectedEntities_one: '{{count}} entité sélectionnée',
  xSelectedEntities_other: '{{count}} entités sélectionnées',
  xSelectedItems_one: '{{count}} item sélectionné',
  xSelectedItems_other: '{{count}} items sélectionnés',
};

export default entities;
